import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {
  constructor() {}
  encrypt(field: any): string {
    return CryptoJS.AES.encrypt(field, 'iIUsWtNZcf').toString();
  }

  decrypt(cypherStr: any): string {
    const bytes = CryptoJS.AES.decrypt(
      cypherStr.toString(),
      'iIUsWtNZcf',
    );
    return bytes.toString(CryptoJS.enc.Utf8);
  }  
}
